const ROLE_KEY = "fps_role";
const USER_KEY = "fps_username";
const AUTH_FLAG = "fps_authed";

/** UI profile only — JWT lives in HttpOnly cookie set by the API. */
export function getRole() {
  return sessionStorage.getItem(ROLE_KEY);
}

export function getUsername() {
  return sessionStorage.getItem(USER_KEY);
}

export function isAuthenticated() {
  return sessionStorage.getItem(AUTH_FLAG) === "1";
}

export function saveProfile({ username, role }) {
  sessionStorage.setItem(AUTH_FLAG, "1");
  if (username) sessionStorage.setItem(USER_KEY, username);
  if (role) sessionStorage.setItem(ROLE_KEY, role);
}

export function clearSession() {
  sessionStorage.removeItem(AUTH_FLAG);
  sessionStorage.removeItem(ROLE_KEY);
  sessionStorage.removeItem(USER_KEY);
}
